<template>
  <div class="row mt-5 justify-content-center">
    <div class="col col-sm-8 col-md-6">
      <div class="alert alert-primary text-center">
        <div class="fs-3">Loading...</div>
        <div class="progress mt-3" role="progressbar">
          <div
            class="progress-bar progress-bar-striped progress-bar-animated"
            :style="`width: 100%`"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingBar"
};
</script>
